import { render, staticRenderFns } from "./bio-link-item.vue?vue&type=template&id=47e85e7a&scoped=true&"
import script from "./bio-link-item.vue?vue&type=script&lang=js&"
export * from "./bio-link-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e85e7a",
  null
  
)

export default component.exports